<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item>
					<el-input v-model="filters.name" placeholder="名称" ></el-input>
				</el-form-item>
                <el-form-item>
					<el-input v-model="filters.keyword" placeholder="关键字"></el-input>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="factors" highlight-current-row v-loading="listLoading"  style="width: 100%;" border  :height="formHeight" size="mini">
			<el-table-column type="index" label="序号" width="60">
			</el-table-column>
			<el-table-column prop="name" label="名称" sortable>
			</el-table-column>
			<el-table-column prop="keyword" label="关键字">
			</el-table-column>
			<el-table-column prop="unit" label="单位" >
			</el-table-column>
			<el-table-column prop="remark" label="描述"  sortable>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[ 10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--From界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false">
			<el-form :model="formFactor" label-width="100px" :rules="formRules" ref="formFactor">
				<el-form-item label="名称" prop="name">
					<el-input v-model="formFactor.name" ></el-input>
				</el-form-item>
				<el-form-item label="关键字"  prop="keyword">
						<div v-if='type=="修改"'>
							<el-input v-model="formFactor.keyword"  :disabled="true"></el-input>
						</div>
						<div v-else>
							<el-input v-model="formFactor.keyword" ></el-input>
						</div>
				</el-form-item>
				<el-form-item label="单位" prop="unit">
                    <el-input v-model="formFactor.unit" ></el-input>
				</el-form-item>
				<el-form-item label="描述">
                    <el-input v-model="formFactor.remark" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import util from '../../common/js/util'
	import { getFactorList,getFactors,addFactor,updateFactor} from '../../api/api';

	import TableSettingButton from '../../components/myButton/TableSettingButton.vue'
    import myButton from '../../components/myButton/index.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { TableSettingButton,myButton,TableUpdateButton},
		data() {
            var reg = new RegExp(/^[a-z][a-z\d]+$/);
            var validateKeyWord = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入关键字'));
                } else if(!reg.test(value)) {
                    callback(new Error('请输入小写字母或数字,且以字母开头'));
                }else {
                    callback()
                }
            };
			return {
				filters: {
                    name: '',
                    keyword:''
				},
				factors: [],
				total: 0,
                page:1,
				pageSize:10,
				listLoading: false,
				sels: [],//列表选中列

				formVisible: false,//修改界面是否显示
                loading: false,
                formRules: {
					name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    keyword: [
						{ required: true,validator: validateKeyWord, trigger: 'blur' }
					],
                    unit: [
						{ required: true,message: '请输入单位',trigger: 'blur' }
					]
				},
				formHeight:0,
				//界面数据
				formFactor: {
					factorId: 0,
					name: '',
					keyword: '',
					unit: '',
					remark: '',
                },
				type:'新增',
				
				factorVisible:false,
				factorColorList:[],
				fatherUserId:1
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getFactors();
				}else if(type=="add"){
					this.handleAdd();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getFactors();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getFactors();
			},
			//获取因子列表
			getFactors() {
				let para = {
                    page: this.page,
                    pageSize:this.pageSize,
                    name: this.filters.name,
					keyword:this.filters.keyword
				};
				this.listLoading = true;
				getFactorList(para).then((res) => {
					this.listLoading = false;
					this.total = res.data.data.total;
					this.factors = res.data.data.factors;
					this.getAllFactors();
				});
			},
			//查询因子信息
			getAllFactors() {
				getFactors().then((res) => {
					//把因子信息存入sessionStorage
					sessionStorage.setItem('facs', JSON.stringify(res.data.data));
					//把单个因子存入sessionStorage
					res.data.data.forEach(element => {
						var obj={};
						obj.name=element.name;
						obj.unit=element.unit;
						obj.keyWord=element.keyword;
						obj.remark=element.remark;
						sessionStorage.setItem(element.keyword, JSON.stringify(obj));
					});
				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.formVisible = true;
				if( this.$refs.formFactor!=undefined){
               		this.$refs.formFactor.resetFields();
				}
                this.type='修改';
				this.formFactor = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
                this.formVisible = true;
                if( this.$refs.formFactor!=undefined){
               		this.$refs.formFactor.resetFields();
				}
				this.type='新增';
				this.formFactor={
					factorId: 0,
					name: '',
					keyword: '',
					unit: '',
					max:10000,
					code:'',
					warningNum:6,
					formMax:10000,
					formMin:0,
					decimalPoint:-1,
					remark: ''
                }
            },
            //Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
            },
			//添加
			addSubmit: function () {
				this.$refs.formFactor.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							
							var para=new URLSearchParams();
							para.append('keyword', this.formFactor.keyword);
							para.append('name',this.formFactor.name);
							para.append('remark',this.formFactor.remark);
							para.append('unit',this.formFactor.unit);

                            addFactor(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
                                this.formVisible = false;                                
                                this.getFactors();
                            });
						});
					}
				});
            },
            //修改
			editSubmit: function () {
				if(this.fatherUserId!=0){
					this.$message({
						message: "权限不足，暂时无法修改",
						type: 'error'
					})
					return;
				}
				this.$refs.formFactor.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;

							var para=new URLSearchParams();
							para.append('keyword', this.formFactor.keyword);
							para.append('name',this.formFactor.name);
							para.append('remark',this.formFactor.remark);
							para.append('unit',this.formFactor.unit);
							para.append('factorId',this.formFactor.factorId);
							
                            updateFactor(para).then((res) => {
								this.loading = false;
								let resData = res.data;
								if (resData.code == 200) {
									this.$message({
										message: '操作成功',
										type: 'success'
									});
								}else{
									this.$message({
										message: resData.msg,
										type: 'error'
									})
								}
                                this.formVisible = false;                                
                                this.getFactors();
                            });
						});
					}
				});
			},
            //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
				this.factorVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var user =JSON.parse(sessionStorage.getItem("user"));
			if(user==null){
				this.$message({
					message: "用户已离线，请重新登录",
					type: 'error'
				})
				this.$router.push({ path: '/login' });
				return;
			}else{
				this.fatherUserId=user.fatherUserId;
			}
			
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getFactors();
		}
	}

</script>
<style>
	#colorUL {
		height: 250px;
	}
	#colorUL li{
		float: left;
		list-style: none;
		width: 20%;
		margin: 5px 0;
	}
	.color{
		float: left;
		width: 60px;
		height: 30px;
		margin-right: 5px;
	}
	#colorUL .colorNum{
		float: left;
		width: 70px;
	}
</style>



// WEBPACK FOOTER //
// Factor.vue?1e77d995